import { Layout, SkipLink, Spinner } from "@vwfs-bronson/bronson-react";
// import BillingAddress from '../components/paymentPage/billingAddress/BillingAddressForm'; // DISABLED: billing address removed from payment flow
import { StepsWizard } from "../components/common/StepsWizard";
import PaymentsHeader from "../components/paymentPage/PaymentsHeader";
import AdyenDropIn from "../components/paymentPage/adyen/AdyenDropIn";
import { usePayments } from "../hooks/usePayments";
import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { trackOnPaymentPage } from "../adobeTracking/trackers";
import { useNotification } from "../hooks/useNotification";
import { useTranslation } from "react-i18next";

export const PaymentPage = () => {
  const { loadingPayment, paying, transaction } =
    usePayments();
  const { handleDeleteAllNotifications } = useNotification();
  const { login, auth, authResponse } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    if (!auth || !login || !authResponse) {
      handleDeleteAllNotifications();
      navigate("/");
      return;
    }
    if (transaction?.isAlreadyFinished) {
      navigate("/confirmation/success");
      return;
    }
    if (!transaction && !loadingPayment) {
      navigate("/overview");
      return;
    }
    // setTransaction(undefined); // DISABLED: transaction is pre-set from OverviewPage before navigation
    trackOnPaymentPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSkipLink = (e: any) => {
    e.preventDefault();
    const main = document.getElementById("maincontent");
    if (main) {
      main.focus();
      main.scrollIntoView();
    }
  };

  return (
    <>
      <SkipLink
        href="#maincontent"
        label="Passer au contenu principal"
        onClick={handleSkipLink}
      />
      <Layout center>
        {/* <StepsWizard activeStep={transaction?.sessionId ? 5 : 4} /> */}
        {/* DISABLED: old 5-step flow with billing address */}
        <StepsWizard activeStep={4} />
        <Layout.Item></Layout.Item>
        <PaymentsHeader />
        {/* <BillingAddress /> */}
        {/* DISABLED: billing address removed from payment flow */}
        {transaction && transaction.sessionId && <AdyenDropIn />}
        {loadingPayment && (
          <Spinner fullPage>{t("paymentpage:spinner:loadingPayment")}</Spinner>
        )}
        {paying && (
          <Spinner fullPage>{t("paymentpage:spinner:paying")}</Spinner>
        )}
      </Layout>
    </>
  );
};
